export default async function sendUserlistActivityEvent() {
    const $userlistMetaTag = $('meta[name="rotowire-content"]');
    if ($userlistMetaTag.length === 0) { return; }

    const section = $userlistMetaTag.data('section');
    const category = $userlistMetaTag.data('category');
    if (!section || !category) { return; }

    try {
        await $.ajax({
            type   : 'GET',
            url    : '/frontend/ajax/trigger-site-use.php',
            data   : { section, category },
            timeout: 10000,
        });
    }
    catch (error) {
        // Fail silently
    }
}
